<template>
  <div class="error-message text-left" :class="`text-${errorVariant}`">
    <slot></slot>
  </div>
</template>

<script>
export default {
  props: {
    errorVariant: {
      type: String,
      default: 'danger',
    },
  },
};
</script>

<style scoped lang="scss">
.error-message {
  font-size: 0.8em;
  padding: 0.3rem 0;
  border-radius: $border-radius;
  background: white;
}
</style>
